var _circle, _rect, _path, _path2, _path3, _path4, _path5, _circle2, _path6, _path7;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlien(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 126,
    viewBox: "0 0 99 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 48.5,
    r: 48.5,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 54,
    width: 97,
    height: 54,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00001 108C1.00001 108 1.00001 116.286 1.00001 121.5C0.999998 126.714 21.1097 125.211 21.1097 108C11.8705 108 1.00001 108 1.00001 108Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1097 108C21.1097 125.211 37.6707 125.211 37.6707 125.211C37.6707 125.211 51.1282 120.465 54.2317 108C54.2317 108 34.1219 108 21.1097 108Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2317 108C56.5974 125.211 69.6097 125.211 69.6097 125.211C69.6097 125.211 77.8901 125.211 80.256 108C63.695 108 54.2317 108 54.2317 108Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.256 108C79.073 125.211 98 125.211 98 125.211V108H80.256Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00001 108C1.00001 108 1.00001 116.286 1.00001 121.5C0.999998 126.714 21.1097 125.211 21.1097 108M1.00001 108H98M1.00001 108C1.00001 108 11.8705 108 21.1097 108M21.1097 108C21.1097 125.211 37.6707 125.211 37.6707 125.211C37.6707 125.211 51.1282 120.465 54.2317 108M21.1097 108C34.1219 108 54.2317 108 54.2317 108M54.2317 108C56.5974 125.211 69.6097 125.211 69.6097 125.211C69.6097 125.211 77.8901 125.211 80.256 108M54.2317 108C54.2317 108 63.695 108 80.256 108M80.256 108C79.073 125.211 98 125.211 98 125.211V108M80.256 108H98",
    stroke: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 47,
    r: 6,
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5 47.3458C77.5 50.6595 75.0376 53.3458 72 53.3458C68.9624 53.3458 66.5 50.6595 66.5 47.3458C66.5 44.0321 68.9624 41.3458 72 41.3458C75.0376 41.3458 77.5 44.0321 77.5 47.3458Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40 57C40 57 49 68.5001 62 57",
    stroke: "black",
    strokeWidth: 3
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlien);
export default __webpack_public_path__ + "static/media/alien.9a62a7c3d86fbac29ba4a031c4c38df4.svg";
export { ForwardRef as ReactComponent };